import {ServicioAdicional} from "../../entities/catalogos/ServicioAdicional";

export const LOAD_CATEGORIAS_SERVICIOS_SUCCESS = 'LOAD_CATEGORIAS_SERVICIOS_SUCCESS';
export const UPDATE_SERVICIO = 'UPDATE_SERVICIO';
export const UPDATE_SERVICIOS = 'UPDATE_SERVICIOS';

export interface ICategoriaServicio {
    etiquetaCategoriaServicioAdicional: any;
    id: number
    nombre: string
    expanded: boolean
}

interface ILoadCategoriasServicios {
    type: typeof LOAD_CATEGORIAS_SERVICIOS_SUCCESS
    categorias: ICategoriaServicio[]
}

interface IUpdateServicio {
    type: typeof UPDATE_SERVICIO
    servicioAdicional: ServicioAdicional
}

interface IUpdateServicios {
    type: typeof UPDATE_SERVICIOS
    serviciosAdicionales: ServicioAdicional[]
}

export type ServicioAdicionalActionTypes =
    ILoadCategoriasServicios
    | IUpdateServicio
    | IUpdateServicios
